<template>

    <Container fluid v-if="featured">

        <Grid>

            <Column :span="[ 2, 5, 5, 4 ]" >

                <Anchor external :route="data?.link">

                    <Heading tag="h2" purple no-margin>
                        {{ data?.title }} <ExternalLink class="osp__share ml-2 lg:ml-3 inline"/>
                    </Heading>

                </Anchor>

            </Column>

        </Grid>

        <Grid class="mt-8">

            <Column :span="[ 2, 3, 4 ]">

                <Anchor external :route="data?.link" class="md:pr-8 lg:pr-16 mt-2">

                    <Picture :image="data?.image" :height="data?.image ? '100%' : '400px'" width="100%" cover/>

                </Anchor>

            </Column>

            <Column :span="[ 2, 3, 2 ]" class="sm:mt-6">

                <Paragraph class="osp__item" :class="{ '--missing-desc': !data.description }" no-margin>
                    {{ data?.category?.title ?? '' }}
                </Paragraph>

                <Paragraph class="osp__item" no-margin>
                    {{ isCNLocale ? `${data.downloads}的下载` : `${data.downloads} Downloads` }}
                </Paragraph>

                <Paragraph class="osp__item" no-margin>
                    {{ isCNLocale ? `${data.stars}的星标` : `${data.stars} Stars` }}
                </Paragraph>

                <Paragraph class="pt-10" v-if="data.description" v-html="data?.description"/>

            </Column>

        </Grid>

    </Container>

    <Container v-else fluid>

        <Grid>

            <Column :span="4" class="sm:mt-4">

                <Anchor external :route="data?.link" :class="[ { 'md:pl-8': featured } ]">

                    <Heading tag="h2" no-margin purple>
                        {{ data?.title }} <ExternalLink class="osp__share ml-2 lg:ml-3 inline"/>
                    </Heading>

                </Anchor>

                <Paragraph v-if="data.description" :class="[ 'pt-4', { 'md:pl-8': featured } ]" v-html="data?.description"/>

            </Column>

            <Column :span="2" class="mt-3">

                <Paragraph class="osp__item" no-margin>
                    {{ data?.category?.title ?? '' }}
                </Paragraph>

                <Paragraph class="osp__item" no-margin>
                    {{ isCNLocale ? `${data.downloads}的下载` : `${data.downloads} Downloads` }}
                </Paragraph>

                <Paragraph class="osp__item" no-margin>
                    {{ isCNLocale ? `${data.stars}的星标` : `${data.stars} Stars` }}
                </Paragraph>

            </Column>

        </Grid>

    </Container>

</template>

<script lang="ts">

    import { defineComponent, PropType } from 'vue'
    import { PackageInterface } from '../Interfaces/MetricsInterface'
    import Column from './Grid/Column.vue'
    import Grid from './Grid/Grid.vue'
    import Container from './Container.vue'
    import Paragraph from './Paragraph.vue'
    import Picture from './Picture.vue'
    import Heading from './Heading.vue'
    import ExternalLink from './Icons/ExternalLink.vue'
    import Anchor from './Anchor.vue'
    import { Route } from '../enums/Route'
    import { useTranslation } from '../compositions/UseTranslation'
    import { useCms } from '../compositions/UseCms'

    export default defineComponent({
        name: 'OpenSourcePackage',
        components: {
            Column,
            Grid,
            Container,
            Anchor,
            ExternalLink,
            Heading,
            Paragraph,
            Picture
        },
        props: {
            data: { type: Object as PropType<PackageInterface>, required: true },
            featured: { type: Boolean, default: false }
        },
        setup() {

            const { isCNLocale } = useCms()

            return {
                Route,
                isCNLocale
            }

        }
    })

</script>

<style lang="scss">

    @include component(osp) {

        @include part(share) {

            transform: translateY(-3px);

        }

        @include part(item) {

            @apply py-5;

            margin-top: 0;
            border-bottom: 1px solid #cccccc;

            @screen md {

                &:first-child {

                    padding-top: 0;

                    @include option(missing-desc) {

                        padding-top: 28px;

                    }

                }

            }

        }

    }

</style>
